<div class="container" *ngIf="verified">
  <div class="page-title">Email Verification</div>
  <div class="page-sub-title">Success! Welcome to MindBerry</div>
</div>

<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50 nopadding-mobile" *ngIf="verified">
  <div class="panel-auth">
    <img class="title-img" src="/images/veri-a.jpg" />

    <div class="col-md-10 col-sm-12 col-md-offset-1 col-sm-offset-0">
      <h5 class="page-title">verification complete</h5>

      <div class="panel-title">
        Congratulations on creating <br>an account with MindBerry.
      </div>

      <div class="push-up-20">
        <div class="profile-sec-wrap">
          <div class="panel-sub-title">
            An email has been sent to you with more information about the application process and the documents we require you to submit for vetting.
            <br /><br />
            If your application is successful, we will approve your account and you will be able to purchase a membership and set up your profile.
          </div>
        </div>
      </div>

      <div class="col-sm-8 col-sm-offset-2 push-down-10 push-up-30">
        <a class="btn-main-proceed-alt" routerLink="/login">My Account</a>
      </div>

      <div class="clear"></div>
    </div>
    <div class="clear"></div>
  </div>
  <div class="clear"></div>
</div>

<div class="clear"></div>
